<div class="catalogPagination">
  <ng-container *ngIf="state.currentRefinement > 0">
    <button
      class="catalogPagination__prevNextButton catalogPagination__prevNextButton--previous"
      (click)="refine($event, state.currentRefinement - 1)"
    >
      <span class="catalogPagination__prevNextButton__arrow"></span>
      <span class="catalogPagination__prevNextButton__text" *ngIf="displayText" i18n="@@FILTERS.PAGINATION.PREVIOUS"
        >Previous</span
      >
    </button>
    <ng-container *ngIf="!SEORulesApply; else paginationFirstElementSSR">
      <button (click)="refine($event, 0)" class="catalogPagination__pageLink">1</button>
    </ng-container>
    <ng-template #paginationFirstElementSSR>
      <ng-container *ngIf="isCrawlable">
        <a [routerLink]="[url + '/.']" class="catalogPagination__pageLink">1</a>
      </ng-container>
    </ng-template>
    <span *ngIf="state.currentRefinement > 1" class="catalogPagination__pageLink">...</span>
  </ng-container>

  <ng-container *ngIf="!SEORulesApply; else paginationSSR">
    <ng-container *ngFor="let page of mapPages(state.pages, state.currentRefinement)">
      <button
        (click)="refine($event, page)"
        class="catalogPagination__pageLink"
        [class.catalogPagination__pageLink--active]="state.currentRefinement === page"
      >
        {{ page + 1 }}
      </button>
    </ng-container>
  </ng-container>

  <ng-template #paginationSSR>
    <ng-container *ngIf="isCrawlable">
      <ng-container *ngFor="let page of mapPages(state.pages, state.currentRefinement)">
        <ng-container *ngIf="state.currentRefinement !== page; else currentPageSSR">
          <a [routerLink]="[url + (page !== 0 ? 'p-' + (page + 1) : '') + '/.']" class="catalogPagination__pageLink">
            <span (click)="refine($event, page)">{{ page + 1 }}</span>
          </a>
        </ng-container>
        <ng-template #currentPageSSR>
          <button class="catalogPagination__pageLink catalogPagination__pageLink--active">
            {{ page + 1 }}
          </button>
        </ng-template>
      </ng-container>
    </ng-container>
  </ng-template>

  <span
    *ngIf="state.currentRefinement + 2 < getFinalBoundPageNumber(state.nbPages) - state.widgetParams?.padding"
    class="catalogPagination__pageLink"
    >...</span
  >

  <ng-container
    *ngIf="getFinalBoundPageNumber(state.nbPages) > state.currentRefinement + 1 + state.widgetParams?.padding"
  >
    <ng-container *ngIf="!SEORulesApply || state.nbPages === 3; else paginationEndPageSSR">
      <button (click)="refine($event, getFinalBoundPageNumber(state.nbPages) - 1)" class="catalogPagination__pageLink">
        {{ getFinalBoundPageNumber(state.nbPages) }}
      </button>
    </ng-container>
    <ng-template #paginationEndPageSSR>
      <a
        class="catalogPagination__pageLink"
        [routerLink]="[url + 'p-' + getFinalBoundPageNumber(state.nbPages) + '/.']"
        *ngIf="isCrawlable"
      >
        <span (click)="refine($event, getFinalBoundPageNumber(state.nbPages) - 1)">{{
          getFinalBoundPageNumber(state.nbPages)
        }}</span>
      </a>
    </ng-template>
  </ng-container>

  <button
    class="catalogPagination__prevNextButton catalogPagination__prevNextButton--next"
    (click)="refine($event, state.currentRefinement + 1)"
    *ngIf="state.currentRefinement + 1 < state.nbPages"
  >
    <span class="catalogPagination__prevNextButton__text" *ngIf="displayText" i18n="@@FILTERS.PAGINATION.NEXT"
      >Next</span
    >
    <span class="catalogPagination__prevNextButton__arrow"></span>
  </button>
</div>
